export default "__VITE_ASSET__DfNarNmw__"